import '../ios';
import '../common';

import { initializeActivityTracking } from '../url-activity-tracking';

initializeActivityTracking();
